import { TypedTypePolicies } from 'owa-graph-schema-type-policies';

export const folderTypePolicies: TypedTypePolicies = {
    Query: {
        fields: {
            folder(_, { args, toReference }) {
                return toReference({
                    __typename: 'MailFolder',
                    id: args.id,
                });
            },
        },
    },
};
